import { internalProviderName } from "components/layout/layout.constant";
import type { UserAttributes } from "hooks/authentication";
import type { CdcUserAttributes } from "models/cdcUser";
import type { ColorSearchSettings } from "models/colors";
import { getDataFromLocalstorageByKey } from "./get-data-localstorage";

export const getUserType = (user: UserAttributes | undefined) => {
  if (!user) return "";
  const userLoginInfo = JSON.parse(
    user?.identities ? user?.identities : "",
  ).pop();
  return userLoginInfo?.providerName ? userLoginInfo?.providerName : "";
};

export const checkInternalUser = (
  user: UserAttributes | undefined,
  settings: ColorSearchSettings,
) => {
  const cdcUser: CdcUserAttributes | undefined =
    getDataFromLocalstorageByKey("cdcUser");
  if (cdcUser) {
    return false;
  } else {
    if (!user) return false;
    const userLoginInfo = JSON.parse(
      user?.identities ? user?.identities : "",
    ).pop();
    const providerName = userLoginInfo?.providerName
      ? userLoginInfo?.providerName
      : "";
    return (
      providerName === internalProviderName && !settings.externalViewVisible
    );
  }
};

const DISTRIBUTOR_ROLE = "Distributor";

export const checkIsDistributor = (
  cdcUser: CdcUserAttributes | undefined,
): boolean => {
  return cdcUser?.extData?.work?.cov_job_title === DISTRIBUTOR_ROLE;
};

export const canUseConventionalSearch = (
  user: UserAttributes | undefined,
  settings: ColorSearchSettings,
): boolean => {
  const cdcUser: CdcUserAttributes | undefined =
    getDataFromLocalstorageByKey("cdcUser");
  if (cdcUser) {
    return checkIsDistributor(cdcUser);
  }
  return checkInternalUser(user, settings);
};
